define("calendar/utils/markupBuilders", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  const getPostStatusAndMethodMarkup = _ref => {
    let {
      className = '',
      icon = '',
      text = '',
      overlay = ''
    } = _ref;
    return `<span class='${className}'><span class='${icon}'></span> ${text}</span>${overlay}`;
  };

  const getUniversalPostMarkup = (eventId, profileColorClass, imageOrTextMarkup) => {
    return `
  <div class='fc-content fc-event-${eventId} ${profileColorClass}'>
    ${imageOrTextMarkup}
  </div>`;
  };

  const getEventTimeMarkup = formattedEventTime => {
    return `<div class='fc-event-time'>${formattedEventTime}</div>`;
  };

  const getTextPostMarkup = caption => {
    return `<p class="fc-event-text">${caption}</p>`;
  };

  const getImagePostMarkup = calendarOrProcessingUrl => {
    return `
    <div class='fc-event-img'>
      <img src='${calendarOrProcessingUrl}'>
    </div>`;
  };

  const getBttpSvgMarkup = () => {
    return `
    <svg class='fc-bttp-icon' width='100%' height='100%' viewBox='0 0 28 28' version='1.1' xmlns='http://www.w3.org/2000/svg' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;'>
      <path d='M14,27.758C13.998,27.758 3.504,27.038 3.5,19.06C3.497,12.163 10.86,3.284 13.256,0.577C13.445,0.366 13.716,0.246 13.999,0.246C14.282,0.247 14.552,0.369 14.74,0.58C17.132,3.309 24.503,12.267 24.5,19.06C24.496,27.296 14,27.758 14,27.758ZM13.561,16.551C13.661,16.413 13.822,16.331 13.992,16.331C14.163,16.331 14.323,16.413 14.423,16.551C15.056,17.436 15.72,18.461 16.266,19.526C16.843,20.653 17.319,21.817 17.318,22.874C17.317,23.948 16.573,24.465 15.897,24.764C15.121,25.107 14.346,25.216 14.033,25.248L14.026,25.248C13.707,25.208 12.917,25.08 12.126,24.72C11.45,24.413 10.683,23.914 10.682,22.874C10.681,21.799 11.155,20.627 11.733,19.497C12.274,18.439 12.932,17.426 13.561,16.551ZM19.798,23.337C19.811,23.188 19.818,23.034 19.818,22.875C19.82,19.351 16.332,14.79 14.757,12.908C14.569,12.684 14.292,12.554 13.999,12.553C13.706,12.552 13.428,12.681 13.24,12.905C11.662,14.772 8.18,19.299 8.182,22.875C8.182,22.994 8.186,23.111 8.194,23.223C6.974,22.339 6.001,21.036 6,19.058C5.999,16.673 7.082,14.034 8.437,11.552C10.029,8.634 12.044,5.941 13.57,4.07C13.674,3.944 13.828,3.871 13.992,3.872C14.155,3.872 14.309,3.945 14.412,4.072C15.936,5.955 17.962,8.675 19.56,11.604C20.915,14.086 22.001,16.711 22,19.058C21.999,21.115 21.024,22.45 19.798,23.337Z' fill='currentColor'/><path d='M14,29.758C14.029,29.758 14.059,29.757 14.088,29.756C14.088,29.756 17.068,29.631 20.048,28.331C23.304,26.91 26.498,24.169 26.5,19.061C26.5,19.061 26.5,19.061 26.5,19.061C26.501,16.048 25.249,12.634 23.51,9.448C21.073,4.982 17.731,0.959 16.244,-0.738C16.24,-0.742 16.237,-0.746 16.233,-0.751C15.668,-1.385 14.857,-1.751 14.006,-1.754C14.004,-1.754 14.001,-1.754 13.999,-1.754C13.148,-1.754 12.334,-1.392 11.766,-0.757C11.764,-0.755 11.761,-0.752 11.758,-0.749C10.267,0.936 6.925,4.929 4.487,9.396C2.751,12.578 1.499,16.003 1.5,19.061C1.5,19.061 1.5,19.061 1.5,19.061C1.502,24.01 4.677,26.765 7.932,28.226C10.961,29.584 13.999,29.758 14,29.758ZM14,27.758C13.998,27.758 3.504,27.038 3.5,19.06C3.497,12.163 10.86,3.284 13.256,0.577C13.445,0.366 13.716,0.246 13.999,0.246C14.282,0.247 14.552,0.369 14.74,0.58C17.132,3.309 24.503,12.267 24.5,19.06C24.496,27.296 14,27.758 14,27.758ZM13.561,16.551C13.661,16.413 13.822,16.331 13.992,16.331C14.163,16.331 14.323,16.413 14.423,16.551C15.056,17.436 15.72,18.461 16.266,19.526C16.843,20.653 17.319,21.817 17.318,22.874C17.317,23.948 16.573,24.465 15.897,24.764C15.121,25.107 14.346,25.216 14.033,25.248L14.026,25.248C13.707,25.208 12.917,25.08 12.126,24.72C11.45,24.413 10.683,23.914 10.682,22.874C10.681,21.799 11.155,20.627 11.733,19.497C12.274,18.439 12.932,17.426 13.561,16.551ZM19.798,23.337C19.811,23.188 19.818,23.034 19.818,22.875C19.82,19.351 16.332,14.79 14.757,12.908C14.569,12.684 14.292,12.554 13.999,12.553C13.706,12.552 13.428,12.681 13.24,12.905C11.662,14.772 8.18,19.299 8.182,22.875C8.182,22.994 8.186,23.111 8.194,23.223C6.974,22.339 6.001,21.036 6,19.058C5.999,16.673 7.082,14.034 8.437,11.552C10.029,8.634 12.044,5.941 13.57,4.07C13.674,3.944 13.828,3.871 13.992,3.872C14.155,3.872 14.309,3.945 14.412,4.072C15.936,5.955 17.962,8.675 19.56,11.604C20.915,14.086 22.001,16.711 22,19.058C21.999,21.115 21.024,22.45 19.798,23.337ZM13.991,19.542C13.824,19.825 13.664,20.114 13.514,20.408C13.514,20.408 13.514,20.408 13.514,20.408C13.11,21.197 12.722,21.997 12.685,22.748C12.763,22.796 12.881,22.866 12.953,22.899C12.953,22.899 12.954,22.899 12.954,22.9C13.366,23.087 13.777,23.182 14.05,23.23C14.311,23.19 14.7,23.106 15.088,22.935C15.15,22.907 15.252,22.847 15.316,22.807C15.296,22.051 14.897,21.241 14.486,20.438C14.331,20.135 14.164,19.835 13.991,19.542ZM13.987,6.768C12.743,8.391 11.35,10.388 10.193,12.51C10.193,12.51 10.193,12.51 10.192,12.51C9.601,13.593 9.054,14.705 8.655,15.806C9.73,14.057 10.935,12.534 11.708,11.619C12.277,10.941 13.119,10.55 14.006,10.553C14.888,10.556 15.723,10.948 16.289,11.622C16.29,11.623 16.29,11.624 16.291,11.624C17.062,12.546 18.261,14.072 19.332,15.816C18.933,14.732 18.39,13.635 17.805,12.562C17.804,12.562 17.804,12.562 17.804,12.562C16.638,10.424 15.233,8.404 13.987,6.768Z' fill='#fff'/>
    </svg>
    `;
  };

  const getNoteHintMarkup = (formattedDate, notesLength) => {
    return `
  <span class='fc-note-${formattedDate}'>
    <span class='u--text--hl'>(${notesLength})</span>
    <span class='fc-icon-note'></span>
  </span>`;
  };

  const getNoteMarkup = (intlService, noteSummary) => {
    return `
  <span class='fc-action'>
    <span class='fc-icon-move'></span>
  </span>
  <span class='fc-note_icon'>
    <span class='fc-icon-note'></span>
  </span>
   <div class='fc-note_text'>
     ${noteSummary}
   </div>
   <span class='fc-note_hint'>
     ${intlService.t('calendar_notes.view_note')}
   </span>`;
  };

  const getBttpPromoMarkup = intlService => {
    return `
    <button class='o--btn--a11y u--p__r__sm'>${intlService.t('bttp.discoverability.enable_your_bttp')}</button>
    <svg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M14 27.758C13.998 27.758 3.504 27.038 3.5 19.06C3.497 12.163 10.86 3.28397 13.256 0.576972C13.445 0.365972 13.716 0.245972 13.999 0.245972C14.282 0.246972 14.552 0.368972 14.74 0.579972C17.132 3.30897 24.503 12.267 24.5 19.06C24.496 27.296 14 27.758 14 27.758ZM13.561 16.551C13.661 16.413 13.822 16.331 13.992 16.331C14.163 16.331 14.323 16.413 14.423 16.551C15.056 17.436 15.72 18.461 16.266 19.526C16.843 20.653 17.319 21.817 17.318 22.874C17.317 23.948 16.573 24.465 15.897 24.764C15.121 25.107 14.346 25.216 14.033 25.248H14.026C13.707 25.208 12.917 25.08 12.126 24.72C11.45 24.413 10.683 23.914 10.682 22.874C10.681 21.799 11.155 20.627 11.733 19.497C12.274 18.439 12.932 17.426 13.561 16.551ZM19.798 23.337C19.811 23.188 19.818 23.034 19.818 22.875C19.82 19.351 16.332 14.79 14.757 12.908C14.569 12.684 14.292 12.554 13.999 12.553C13.706 12.552 13.428 12.681 13.24 12.905C11.662 14.772 8.18 19.299 8.182 22.875C8.182 22.994 8.186 23.111 8.194 23.223C6.974 22.339 6.001 21.036 6 19.058C5.999 16.673 7.082 14.034 8.437 11.552C10.029 8.63397 12.044 5.94097 13.57 4.06997C13.674 3.94397 13.828 3.87097 13.992 3.87197C14.155 3.87197 14.309 3.94497 14.412 4.07197C15.936 5.95497 17.962 8.67497 19.56 11.604C20.915 14.086 22.001 16.711 22 19.058C21.999 21.115 21.024 22.45 19.798 23.337Z' fill='currentColor'/></svg>
  `;
  };

  const getTimeSlotMarkup = () => {
    return `
  <div class='fc-destroy'>
    <span class='fc-icon-close e--fc-slot-destroy'></span>
  </div>
  <span class='fc-action'>
    <span class='fc-icon-move'></span>
  </span>`;
  };

  var _default = {
    bttpSvg: getBttpSvgMarkup,
    noteHint: getNoteHintMarkup,
    note: getNoteMarkup,
    timeSlot: getTimeSlotMarkup,
    bttpPromo: getBttpPromoMarkup,
    universalPostContent: getUniversalPostMarkup,
    postStatusAndMethodContent: getPostStatusAndMethodMarkup,
    eventTime: getEventTimeMarkup,
    imagePost: getImagePostMarkup,
    textPost: getTextPostMarkup
  };
  _exports.default = _default;
});